
export const EMC_DIGI_TYPES_REQUESTED = 'EMC_DIGI_TYPES_REQUESTED';
export const EMC_DIGI_TYPES_SUCCEED = 'EMC_DIGI_TYPES_SUCCEED';
export const EMC_DIGI_TYPES_FAILED = 'EMC_DIGI_TYPES_FAILED';
